/**
 * ================================================================
 * Bisou Rivage — bisou-fiche.js
 * ================================================================
 * Les trois petits gestes de la fiche produit, et rien d'autre.
 * Ce fichier ne touche NI au panier, NI aux variantes, NI a la
 * galerie : il se contente de declencher ce qui existe deja.
 *
 *   1. AGRANDIR — le bouton hors image clique le declencheur de zoom
 *      du theme sur la diapo active. Le modal, le focus et la
 *      fermeture restent ceux de Shopify.
 *   2. EDITION LIMITEE — le badge dore fait basculer le BLOC GRIS de
 *      gauche : le fond passe au noir, l'oeuvre retrecit et glisse vers
 *      la droite, le texte arrive a gauche lettre apres lettre. C'est un
 *      etat de la fiche, pas une page : rien ne navigue, rien n'est
 *      recouvert.
 *   3. REFERENCE — l'infobulle du H-020. Survol gere en CSS ; ici on
 *      ne s'occupe que du tap mobile, qui n'a pas de survol.
 * ================================================================
 */
(function () {
  'use strict';

  /* ══════════════════ 1. AGRANDIR ══════════════════
     La loupe a quitte le coin du mockup : plus rien ne se superpose au
     tirage. Le bouton vit au-dessus de la colonne image et delegue au
     bouton de zoom natif de la diapo visible. */
  function activeZoomTrigger() {
    var active = document.querySelector('.product__media-item.is-active')
              || document.querySelector('.product__media-item');
    var trigger = active && active.querySelector('.product__media-toggle');
    /* Diapo « mise en situation » (mockup maison) : elle n'a pas de modal
       natif, on retombe sur la premiere diapo qui en a un. */
    return trigger || document.querySelector('.product__media-toggle');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-rv5-expand]');
    if (!btn) return;
    e.preventDefault();
    var trigger = activeZoomTrigger();
    if (trigger) trigger.click();
  });

  /* Le clic sur le TIRAGE ouvre aussi le plein ecran, sur ordinateur (Max,
     28/08). Dawn pose deja un calque cliquable sur chaque diapo
     (.product__media-toggle::after) : quand c'est lui qui prend le clic, la
     cible est le bouton, pas l'image, et on ne fait rien de plus — pas de
     double ouverture. On ne rattrape que le clic qui atteint l'image. La
     diapo « mise en situation » n'a pas de modal : on la laisse. */
  document.addEventListener('click', function (e) {
    var img = e.target.closest && e.target.closest('.rv5-media-frame .product__media-item img');
    if (!img) return;
    if (e.target.closest('.rv5-mk-slide')) return;
    var large = false;
    try { large = window.matchMedia('(min-width: 900px)').matches; } catch (err) {}
    if (!large) return;
    var trigger = activeZoomTrigger();
    if (trigger) trigger.click();
  });

  /* ── Zoom dans le plein ecran, a la souris (Max, 28/08) ──
     Chez Dawn, un clic souris N'IMPORTE OU dans la modale la ferme
     (global.js:610, `pointerup` sur .media-modal) — l'image comprise. Ici le
     clic sur l'image ne ferme plus : il double l'image, centree sur le point
     clique, et le second clic la rend entiere. Le clic a cote ferme toujours.

     On ecoute le meme `pointerup`, mais en phase de CAPTURE sur document :
     on passe avant la modale, et stopPropagation l'empeche de fermer. Seul
     le clic sur l'image active est intercepte, rien d'autre ne change.

     Un zoom qui ne survit pas a la fermeture : quand l'attribut `open` tombe,
     on remet l'image entiere, sinon la modale rouvrirait zoomee sur un autre
     tirage. */
  function modalImage(target) {
    return target.closest && target.closest('.product-media-modal__content > .active');
  }

  function dezoomer(modal) {
    if (!modal) return;
    modal.classList.remove('rv5-zoomed');
    var imgs = modal.querySelectorAll('.product-media-modal__content > *');
    for (var i = 0; i < imgs.length; i++) {
      imgs[i].style.width = '';
      imgs[i].style.height = '';
      if (imgs[i].hasAttribute('data-rv5-sizes')) {
        imgs[i].setAttribute('sizes', imgs[i].getAttribute('data-rv5-sizes'));
        imgs[i].removeAttribute('data-rv5-sizes');
      }
    }
  }

  function zoomer(img, e) {
    var modal = img.closest('.product-media-modal');
    var content = img.closest('.product-media-modal__content');
    if (!modal || !content) return;
    var rect = img.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    /* Le point clique, en fraction de l'image : c'est lui qu'on garde sous le
       curseur apres le zoom. */
    var rx = (e.clientX - rect.left) / rect.width;
    var ry = (e.clientY - rect.top) / rect.height;
    var w = Math.round(rect.width * 2);
    var h = Math.round(rect.height * 2);

    /* Une source plus fine pour la taille doublee : `sizes` decide du candidat
       que le navigateur charge, pas la largeur CSS. */
    if (!img.hasAttribute('data-rv5-sizes')) {
      img.setAttribute('data-rv5-sizes', img.getAttribute('sizes') || '');
    }
    img.setAttribute('sizes', w + 'px');

    modal.classList.add('rv5-zoomed');
    img.style.width = w + 'px';
    img.style.height = 'auto';

    var cr = content.getBoundingClientRect();
    content.scrollLeft = img.offsetLeft + rx * w - (e.clientX - cr.left);
    content.scrollTop  = img.offsetTop  + ry * h - (e.clientY - cr.top);
  }

  document.addEventListener('pointerup', function (e) {
    if (e.pointerType !== 'mouse') return;
    var img = modalImage(e.target);
    if (!img) return;
    var modal = img.closest('.product-media-modal');
    if (!modal || !modal.hasAttribute('open')) return;
    e.stopPropagation();
    if (modal.classList.contains('rv5-zoomed')) dezoomer(modal);
    else zoomer(img, e);
  }, true);

  /* Retour a l'image entiere a la fermeture. */
  (function veillerFermeture() {
    var modal = document.querySelector('product-modal.product-media-modal');
    if (!modal || typeof MutationObserver === 'undefined') return;
    new MutationObserver(function () {
      if (!modal.hasAttribute('open')) dezoomer(modal);
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });
  })();

  /* ══════════════════ 2. PANNEAU EDITION LIMITEE ══════════════════
     Le badge dore ne pose plus un calque : il change l'ETAT DU BLOC GRIS.
     Le fond vire au noir, l'oeuvre retrecit et glisse vers la droite, le
     texte prend la place liberee a gauche. Tout le dessin est dans la
     feuille (assets/bisou-variant-ui.css) ; ici on ne fait que poser deux
     classes et decouper le texte.

     Le panneau ne demenage plus sous <body>. Il l'a fait le 26/08 pour qu'un
     `position: fixed` se cale enfin sur la fenetre — un ancetre portait un
     `transform` et capturait le bloc englobant. Il n'y a plus de `fixed` du
     tout : le panneau est cale en absolu sur .product__media-wrapper, qui EST
     la zone grise. Le probleme n'existe plus, le contournement non plus. */
  function stage() { return document.querySelector('.rv5-media-stage'); }
  function badges() { return document.querySelectorAll('.rv5-edition-tag--gold'); }
  function panel() { return document.getElementById('rv5-edition-panel'); }
  function grey() {
    var pa = panel();
    return pa && pa.closest('.product__media-wrapper');
  }

  var MOINS_DE_MOUVEMENT = window.matchMedia
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── LE TEXTE QUI ARRIVE LETTRE APRES LETTRE ──
     Un <span> par MOT, un <span> par LETTRE dedans. Le niveau MOT n'est pas
     decoratif : sans lui, `display: inline-block` sur chaque lettre autorise
     la ligne a se couper au milieu d'un mot. Avec, elle se coupe encore la ou
     il faut.

     Le pas se CALCULE pour que chaque bloc mette a peu pres le meme temps a
     se remplir, quelle que soit sa longueur. Un pas fixe donnerait 250 ms au
     titre et quatre secondes au paragraphe : on attendrait la fin.

     PAS DE JUMEAU INVISIBLE (Max, 27/08). Le premier jet sortait le texte
     decoupe de l'arbre d'accessibilite et posait a cote une copie
     `visually-hidden`, technique habituelle contre les lecteurs d'ecran qui
     epellent les <span>. Max a vu le titre TROIS fois dans le texte de la
     page : l'exergue, le titre, et la copie. Invisible a l'oeil, mais bien la
     au copier-coller et dans l'arbre du document.

     Le niveau MOT rend la copie inutile : les lettres sont regroupees en mots,
     et un lecteur d'ecran lit le texte rendu, pas la liste des balises. Un mot
     reste un mot. On garde donc UNE seule fois chaque phrase.

     Le decoupage lit `textContent` : le texte servi doit rester du texte nu.
     C'est le cas — product.edition_panel.title et .body sont deux chaines
     simples des locales. Une balise posee dedans serait perdue. */
  var CIBLES = '[data-rv5-reveal]';
  var DUREE_REMPLISSAGE = 900; /* ms que met un bloc a se remplir, environ */

  function decouper(el, base) {
    if (el.__rv5Decoupe) return;

    var texte = el.textContent;
    var lettres = texte.replace(/\s+/g, '').length;
    if (!lettres) { el.__rv5Decoupe = true; return; }
    var pas = Math.min(20, DUREE_REMPLISSAGE / lettres);

    el.textContent = '';
    var rang = 0;

    texte.split(/(\s+)/).forEach(function (bout) {
      if (!bout) return;
      if (/^\s+$/.test(bout)) {
        el.appendChild(document.createTextNode(bout));
        return;
      }
      var mot = document.createElement('span');
      mot.className = 'rv5-rv-word';
      for (var i = 0; i < bout.length; i++) {
        var lettre = document.createElement('span');
        lettre.className = 'rv5-rv-char';
        lettre.textContent = bout.charAt(i);
        lettre.style.transitionDelay = Math.round(base + rang * pas) + 'ms';
        mot.appendChild(lettre);
        rang++;
      }
      el.appendChild(mot);
    });

    el.__rv5Decoupe = true;
  }

  function textes() {
    var pa = panel();
    return pa ? Array.prototype.slice.call(pa.querySelectorAll(CIBLES)) : [];
  }

  /* Le paragraphe part APRES le titre : deux textes qui se remplissent en
     meme temps se lisent comme du bruit. Le retard vaut la duree du titre. */
  function reveler() {
    var blocs = textes();
    if (MOINS_DE_MOUVEMENT) {
      blocs.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }
    blocs.forEach(function (el, i) { decouper(el, i * 320); });
    /* Deux trames avant d'armer : le navigateur doit avoir peint l'etat de
       depart, sinon il n'y a pas de transition, juste un saut. */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        blocs.forEach(function (el) { el.classList.add('is-revealed'); });
      });
    });
  }

  function cacher() {
    textes().forEach(function (el) { el.classList.remove('is-revealed'); });
  }

  function setEdition(open) {
    var st = stage();
    var pa = panel();
    var gr = grey();
    if (!pa || !gr) return;

    /* La zone grise porte l'etat : c'est ELLE qui change de couleur, elle qui
       recule l'oeuvre, elle qui efface la barre d'outils. */
    gr.classList.toggle('rv5-edition-on', open);
    /* La scene garde son ancienne classe : quelques regles heritees s'y
       accrochent encore (.rv5-media-actions sur telephone). */
    if (st) st.classList.toggle('rv5-edition-open', open);

    pa.classList.toggle('is-open', open);
    pa.setAttribute('aria-hidden', open ? 'false' : 'true');

    Array.prototype.forEach.call(badges(), function (b) {
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      b.classList.toggle('is-on', open);
    });

    if (open) {
      reveler();
      var close = pa.querySelector('[data-rv5-edition-close]');
      if (close) close.focus();
    } else {
      cacher();
    }
  }

  function editionIsOpen() {
    var gr = grey();
    return !!(gr && gr.classList.contains('rv5-edition-on'));
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    /* Le badge ouvre ET referme : deuxieme clic = retour au gris. */
    var badge = e.target.closest('.rv5-edition-tag--gold');
    if (badge) {
      e.preventDefault();
      setEdition(!editionIsOpen());
      return;
    }

    if (e.target.closest('[data-rv5-edition-close]')) {
      e.preventDefault();
      setEdition(false);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && editionIsOpen()) setEdition(false);
  });

  /* ══════════════════ 3. INFOBULLE REFERENCE (tap mobile) ══════════════════
     Le survol est fait en CSS (apparition apres 300 ms). Sur un ecran
     tactile il n'y a pas de survol : le tap montre l'infobulle 1,5 s. */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('[data-rv5-tip]');
    if (!chip) return;
    chip.classList.add('is-tapped');
    clearTimeout(chip.__tipTimer);
    chip.__tipTimer = setTimeout(function () {
      chip.classList.remove('is-tapped');
    }, 1500);
  });
})();
